/**
 * Environment-specific product ID mappings for Skills Tutor courses.
 * This maps logical course names to environment-specific Salesforce product IDs.
 */

export const productIdMappings = {
  uat: {
    'customer-service-basic': '01tbh000007UOYlAAO',
    'customer-service-intermediate': '01tbh000007UUMPAA4',
    'job-interview-basic': '01tbh000007UQvXAAW',
    'job-interview-intermediate': '01tbh000007UUZJAA4',
    'meeting-basic': '01tbh000007UUizAAG',
    'meeting-intermediate': '01tbh000007UT5QAAW',
    'negotiation-basic': '01tbh000007UQJAAA4',
    'negotiation-intermediate': '01tbh000007UUz7AAG',
    'presentation-basic': '01tbh000007UV7BAAW',
    'presentation-intermediate': '01tbh000007UQSVAA4',
    'writing-basic': '01tbh000007UVOvAAO',
    'writing-intermediate': '01tbh000007UVQXAA4',
    'social-basic': '01tbh000007UVf3AAG',
    'social-intermediate': '01tbh000007UVAQAA4',
  },
  prod: {
    'customer-service-basic': '01tdk000005PEsvAAG',
    'customer-service-intermediate': '01tdk000005PF5pAAG',
    'job-interview-basic': '01tdk000005PFKLAA4',
    'job-interview-intermediate': '01tdk000005PFQnAAO',
    'meeting-basic': '01tdk000005PFaTAAW',
    'meeting-intermediate': '01tdk000005PFgvAAG',
    'negotiation-basic': '01tdk000005PFtpAAG',
    'negotiation-intermediate': '01tdk000005PG0HAAW',
    'presentation-basic': '01tdk000005PG9xAAG',
    'presentation-intermediate': '01tdk000005PGEnAAO',
    'writing-basic': '01tdk000005PGQ5AAO',
    'writing-intermediate': '01tdk000005PFSRAA4',
    'social-basic': '01tdk000005PGebAAG',
    'social-intermediate': '01tdk000005PGhpAAG',
  },
} as const

export type CourseKey = keyof typeof productIdMappings.uat
export type Environment = keyof typeof productIdMappings

/**
 * Get the product ID for a given course and environment
 */
export const getProductId = (courseKey: CourseKey, environment: Environment): string => {
  return productIdMappings[environment][courseKey]
}

/**
 * Find course key by product ID (reverse lookup)
 */
export const getCourseKeyByProductId = (productId: string, environment: Environment): CourseKey | undefined => {
  const mappings = productIdMappings[environment]
  return (Object.keys(mappings) as CourseKey[]).find((key) => mappings[key] === productId)
}
